// Set the name of the hidden property and the change event for visibility
// as different browser have different property name.
// Check this documentation to know more about this https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
export function getDocumentProperty() {
  let hidden;
  let visibilityChange;

  if (typeof document.hidden != undefined) {
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
  } else if (typeof document.msHidden != undefined) {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
  } else if (typeof document.webkitHidden != undefined) {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  }

  return { hidden, visibilityChange }
}

export function checkHiddenTab() {
  const { hidden } = getDocumentProperty();
  if (hidden !== undefined && document[hidden]) return true;
  return false;
}
